import { getOr } from 'lodash/fp';
import { connect } from 'react-redux';

const modeProvider = (prop, listName, defaultMode = null) => connect((state, { forcedMode }) => ({
    [prop]: forcedMode || getOr(defaultMode, ['lists', listName, 'mode'], state),
}));

export default modeProvider;
